export interface TourStep {
  id: number;
  screen: string;
  targetElement: string;
  title: string;
  body: string;
  autoAdvanceMs: number | null; // null = user tap to advance
}

export const TOUR_STEPS: TourStep[] = [
  {
    id: 0,
    screen: 'dashboard',
    targetElement: '[data-tour="start-workout"]',
    title: 'Start Your First Workout',
    body: 'Tap here to begin your first workout.',
    autoAdvanceMs: 3000,
  },
  {
    id: 1,
    screen: 'dashboard',
    targetElement: '[data-tour="morning-checkin"]',
    title: 'Morning Check-in',
    body: 'Check in every morning to track recovery.',
    autoAdvanceMs: 2500,
  },
  {
    id: 2,
    screen: 'workout',
    targetElement: '[data-tour="rpe-selector"]',
    title: 'Rate Your Effort',
    body: 'Rate your effort after each set.',
    autoAdvanceMs: 2500,
  },
  {
    id: 3,
    screen: 'workout',
    targetElement: '[data-tour="set-logger"]',
    title: 'Log Your Sets',
    body: 'Log your sets here.',
    autoAdvanceMs: null,
  },
  {
    id: 4,
    screen: 'post-workout',
    targetElement: '[data-tour="score-reveal"]',
    title: 'Your Workout Score',
    body: 'Your workout score — watch it grow.',
    autoAdvanceMs: 2000,
  },
  {
    id: 5,
    screen: 'dashboard',
    targetElement: '[data-tour="profile-strength"]',
    title: 'Track Your Progress',
    body: 'Track your progress over time.',
    autoAdvanceMs: null,
  },
];
